import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n";
import { ExternalLink } from "lucide-react";

const eur = (n) => `${(Number(n) || 0).toFixed(2).replace(".", ",")} €`;

// READ-ONLY: Pflege bleibt ausschließlich in B2B → Preislisten.
export const VariantPriceLists = ({ variantId }) => {
  const { t } = useI18n();
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!variantId) return;
    api.get(`/variants/${variantId}/price-lists`).then((r) => setData(r.data)).catch(() => setData(null));
  }, [variantId]);

  if (!data) return null;
  return (
    <div className="col-span-2 rounded-md border border-border bg-muted/30 p-3" data-testid="variant-pricelists">
      <div className="mb-2 flex items-center justify-between">
        <span className="text-xs font-medium uppercase tracking-wide text-muted-foreground">{t("pl.inPriceLists")}</span>
        <Link to="/b2b" className="inline-flex items-center gap-1 text-xs text-primary hover:underline" data-testid="variant-pricelists-link">
          {t("pl.manageThere")} <ExternalLink className="h-3 w-3" />
        </Link>
      </div>
      {data.entries.length === 0 ? (
        <p className="text-xs text-muted-foreground" data-testid="variant-pricelists-empty">{t("pl.notInAnyList")}</p>
      ) : (
        <table className="w-full text-xs">
          <thead className="text-muted-foreground">
            <tr className="text-left">
              <th className="pb-1 pr-2 font-medium">{t("b2b.tabPriceLists")}</th>
              <th className="pb-1 pr-2 text-right font-medium">{t("common.priceNet")}</th>
              <th className="pb-1 pr-2 text-right font-medium">{t("common.priceGross")}</th>
              <th className="pb-1 pr-2 font-medium">{t("pl.validity")}</th>
            </tr>
          </thead>
          <tbody>
            {data.entries.map((e, i) => (
              <tr key={i} className="border-t border-border/60" data-testid={`variant-pricelist-row-${i}`}>
                <td className="py-1 pr-2">{e.price_list_name}{e.archived ? " (—)" : ""}</td>
                <td className="py-1 pr-2 text-right tabular-nums">{eur(e.price_net)}
                  {e.delta_percent != null && <span className="ml-1 text-muted-foreground">({e.delta_percent > 0 ? "+" : ""}{e.delta_percent}%)</span>}
                </td>
                <td className="py-1 pr-2 text-right tabular-nums">{eur(e.price_gross)}</td>
                <td className="py-1 pr-2">{e.valid_from || "—"}{e.valid_to ? ` – ${e.valid_to}` : ""}{e.valid_now ? "" : " (—)"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};
